var map = {
	"./andrey_gradient.png": [
		5338,
		"src_app_assets_pictures_avatars_in_scene_andrey_gradient_png"
	],
	"./andrey_green.png": [
		2625,
		"src_app_assets_pictures_avatars_in_scene_andrey_green_png"
	],
	"./andrey_tungsten.png": [
		9222,
		"src_app_assets_pictures_avatars_in_scene_andrey_tungsten_png"
	],
	"./igor_gradient.png": [
		6200,
		"src_app_assets_pictures_avatars_in_scene_igor_gradient_png"
	],
	"./igor_green.png": [
		3683,
		"src_app_assets_pictures_avatars_in_scene_igor_green_png"
	],
	"./igor_tungsten.png": [
		9952,
		"src_app_assets_pictures_avatars_in_scene_igor_tungsten_png"
	],
	"./irina_gradient.png": [
		9284,
		"src_app_assets_pictures_avatars_in_scene_irina_gradient_png"
	],
	"./irina_green.png": [
		9647,
		"src_app_assets_pictures_avatars_in_scene_irina_green_png"
	],
	"./irina_tungsten.png": [
		8732,
		"src_app_assets_pictures_avatars_in_scene_irina_tungsten_png"
	],
	"./nastya_gradient.png": [
		3237,
		"src_app_assets_pictures_avatars_in_scene_nastya_gradient_png"
	],
	"./nastya_green.png": [
		9512,
		"src_app_assets_pictures_avatars_in_scene_nastya_green_png"
	],
	"./nastya_tungsten.png": [
		1129,
		"src_app_assets_pictures_avatars_in_scene_nastya_tungsten_png"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3539;
module.exports = webpackAsyncContext;